import { render, staticRenderFns } from "./assignment-register-task-modal.vue?vue&type=template&id=2feb9d22&scoped=true"
import script from "./assignment-register-task-modal.vue?vue&type=script&lang=js"
export * from "./assignment-register-task-modal.vue?vue&type=script&lang=js"
import style0 from "./assignment-register-task-modal.vue?vue&type=style&index=0&id=2feb9d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb9d22",
  null
  
)

export default component.exports